import React from 'react';
import type { PromptAttachmentFlags } from '../../utils/promptListAttachments';
import './AttachmentIndicators.css';

const SkillIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" aria-hidden>
    <path d="M13 2L3 14h8l-1 8 10-12h-8z" />
  </svg>
);

const RuleIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" aria-hidden>
    <path d="M12 3l8 3v6c0 4.5-3.2 8.2-8 9-4.8-.8-8-4.5-8-9V6z" />
    <path d="M9 12l2 2 4-4" />
  </svg>
);

const AgentIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" aria-hidden>
    <rect x="4" y="8" width="16" height="12" rx="3" />
    <path d="M12 4v4M9 13h.01M15 13h.01" />
  </svg>
);

export const AttachmentIndicators: React.FC<PromptAttachmentFlags> = ({
  hasSkill,
  hasRule,
  hasAgent,
}) => {
  if (!hasSkill && !hasRule && !hasAgent) {
    return <span className="attachment-indicators attachment-indicators--empty" aria-hidden>—</span>;
  }
  return (
    <span className="attachment-indicators">
      {hasSkill && (
        <span className="attachment-indicators__ic attachment-indicators__ic--skill" role="img" title="Skill attached" aria-label="Skill attached">
          <SkillIcon />
        </span>
      )}
      {hasRule && (
        <span className="attachment-indicators__ic attachment-indicators__ic--rule" role="img" title="Supporting rule attached" aria-label="Supporting rule attached">
          <RuleIcon />
        </span>
      )}
      {hasAgent && (
        <span className="attachment-indicators__ic attachment-indicators__ic--agent" role="img" title="Supporting agent attached" aria-label="Supporting agent attached">
          <AgentIcon />
        </span>
      )}
    </span>
  );
};

export default AttachmentIndicators;
